(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"] && !Shopify.designMode) return;
  try {
    
  // Summary : la liste des liens est générée en Liquid, le JS ne gère que le défilement et l'affichage
   const summary = document.querySelector("#summary");
   if (summary) {
     summary.querySelectorAll('a[href^="#"]').forEach(function(a) {
       a.addEventListener('click', function(e) {
         const title = document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
         if (!title) return;
         e.preventDefault();
         window.scrollTo({ top: title.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
       });
     });

     // Show-Hide
     const summaryTriger = document.querySelector("#summary-show-hide");
     let summaryHeight = summary.offsetHeight;
     summary.style.height = "50px";
     summaryTriger.innerHTML = 'afficher';
     summaryTriger.addEventListener('click', function() {
       if(this.innerHTML == 'afficher') {
         this.innerHTML = 'masquer';
         summary.style.height = summaryHeight + 'px';
       } else {
         this.innerHTML = 'afficher';
         summary.style.height = "50px";
       }
     });
   }

  // FAQ des articles : ouvre/ferme la réponse au clic, même si le script collé dans l'article a été perdu.
  // Si le script de l'article a déjà réagi (aria-expanded a changé), on ne fait rien pour éviter un double toggle.
  document.addEventListener('click', function(e) {
    const button = e.target.closest('.faq-question');
    if (button) button.dataset.faqBefore = button.getAttribute('aria-expanded') || 'false';
  }, true);
  document.addEventListener('click', function(e) {
    const button = e.target.closest('.faq-question');
    if (!button) return;
    const before = button.dataset.faqBefore;
    if ((button.getAttribute('aria-expanded') || 'false') !== before) return;
    button.setAttribute('aria-expanded', before !== 'true');
    button.parentElement.classList.toggle('active');
  });

 
  } catch(e) { console.error(e); }
})();
})();
